import React from 'react';
import SearchBar from './SearchBar';
import POSFilter from './POSFilter';

const ColumnFilters = ({ 
  searchQuery, 
  onSearchChange, 
  posOptions, 
  selectedPos, 
  onPosChange 
}) => {
  return (
    <div className="px-1 py-2 bg-body-tertiary rounded mb-2 border mx-1">
      <SearchBar searchQuery={searchQuery} onSearchChange={onSearchChange} />
      <POSFilter 
        posOptions={posOptions} 
        selectedPos={selectedPos} 
        onPosChange={onPosChange} 
      />
    </div>
  );
};

export default ColumnFilters;
